import { Tooltip } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import { useFieldValue } from './use-field-value';

export function FieldValue(props: Parameters<typeof useFieldValue>[0]) {
  const f = useFieldValue(props);

  const typeIndicator =
    f.typeDisplayMode === 'pill' ? (
      <Tooltip content={f.fieldType}>
        <div className={cn('w-3 h-3 rounded-full', f.typeColorClasses)} aria-label={f.fieldType} />
      </Tooltip>
    ) : (
      <span
        className={cn('text-xs px-1.5 py-0.5 rounded', f.typeFormatClasses, f.typeBadgeClasses)}
      >
        {f.fieldType}
      </span>
    );

  return (
    <div className={cn('flex flex-col gap-1', f.className)}>
      <div className="flex items-center gap-2">
        <span
          className={cn(
            'text-sm text-foreground',
            f.typeFormatClasses,
            f.isClickable && 'cursor-pointer hover:text-primary hover:underline'
          )}
          onClick={f.handleClick}
          title={f.clickTitle}
        >
          {f.displayValue}
        </span>
        {typeIndicator}
      </div>
      {f.showMoreLess && (
        <button
          onClick={f.handleMoreLessClick}
          className="self-start cursor-pointer text-xs text-muted-foreground hover:text-foreground underline"
        >
          {f.moreLessLabel}
        </button>
      )}
    </div>
  );
}
